import './css/font.css';
import { DefaultTheme, createGlobalStyle } from "styled-components";
export { ReactComponent as GrassSVG } from "assets/image/common/C_grass.svg";
export { ReactComponent as BearSVG } from "assets/image/common/C_bear.svg";
export { ReactComponent as DinosaurSVG } from "assets/image/common/C_dinosaur.svg";
export { ReactComponent as TeacherWSVG } from "assets/image/common/C_teacher_w.svg";
export { ReactComponent as TeacherMSVG } from "assets/image/common/C_teacher_m.svg";
export { ReactComponent as ChildSVG } from "assets/image/common/C_child.svg";
export { ReactComponent as PenguinSVG } from "assets/image/common/C_penguin.svg";
export { ReactComponent as DocIcon } from "assets/image/page/doca.svg";

export const colors = {
  white: "#FFFFFF",
  black: "#1A1A1A",
  text_b: "#262626",
  text_g: "#4D4D4D",

  primary: "#1DC487",
  primaryHover: "#179768",
  secondary: "#E8F7F2",
  secondaryHover: "#CAE7DE",
  accent: "#1AAD77",
  mainBg: '#F7F7F7', // light theme 배경

  // color
  red: "#E0062D",
  vermillion: "#EA563D", // 주홍색
  orange: "#F49701",
  yellow: "#F0AB18",
  lightYellow: "#FCF1D9",
  green: "#2EAE4B",
  blue: "#2685F5",
  lightBlue: "#E7F1FE",
  darkGray: "#4D4D4D",
  gray: "#999999",
  lightGray: "#F2F2F2", // disabled bg
  deleteBg: "#F5E4E6", // disabled text
  deleteHover: "#EED2D6",

  // input/textarea/select
  textFieldDefaultBg: "#F7F7F7", // read-only 포함
  textFieldActiveBg: "#F2F8F6",
  textFieldDisabledBg: "#E6E6E6",
  textFieldDisabledText: "#666666", // read-only 포함

  // border
  primaryBd: "#DEDEDE",
  secondaryBd: "#EEEEEE", // select
  thirdBd: "#C4C4C4",
  redBd: "#9E001C",

  // sidemenu
  menuIconColor: "#C4C4C4",
  
};

export const commonTheme: Partial<DefaultTheme['newTheme']> = {
  default: {
    primary: colors.primary,
    secondary: colors.secondary,
    accent: colors.accent,
    error: colors.red,
    text: colors.text_b,
    textGray: colors.text_g,
  },
  text: {
    mainText: colors.text_b,
    btnText_w: colors.white,
    btnText_b: colors.text_b,
    btnText_disabled: colors.gray,
    btnOutlineText :colors.darkGray,
  },
  textField: {
    defaultBg: colors.textFieldDefaultBg,
    activeBg: colors.textFieldActiveBg,
    errorBg: colors.red,
    disabledBg: colors.textFieldDisabledBg,
    disabledText: colors.textFieldDisabledText
  },
  border: {
    primaryBd: colors.primaryBd,
    secondaryBd: colors.secondaryBd,
    thirdBd: colors.thirdBd,
    redBd: colors.redBd,
  },
  table: {
    tableHeadBg: colors.lightGray,
    tableHeadText: colors.darkGray,
    tableBodyHoverBg: colors.lightGray,
  },
  icon: {
    defaultBg: colors.text_g,
    primaryBg: colors.primary,
    defaultText: colors.white,
    grayBg: colors.gray,
    disabledBg: colors.lightGray,
    disabledText: colors.gray,
    successBg: colors.green,
    yellowBg: colors.yellow
  }
};

export const lightTheme: DefaultTheme = {
  rootBlack: colors.black,
  rootWhite: colors.white,
  newTheme: {
    ...(commonTheme as DefaultTheme['newTheme']),
    layer: {
      ...(commonTheme as DefaultTheme['newTheme']).layer,
      mainBackground: colors.mainBg,
    }
  }
};
export const darkTheme: DefaultTheme = {
  rootBlack: colors.black,
  rootWhite: colors.white,
  newTheme: {
    ...(commonTheme as DefaultTheme['newTheme']),
  }
};

const GlobalStyles = createGlobalStyle`
    html {
        scrollbar-width: none; /* for Firefox */
    }
    body {
        width: 100%;
        height: calc(var(--vh, 1vh) * 100);
        margin: 0;
        padding: 0;
        color: ${({theme}) => theme.newTheme.text.mainText};
        background-color: #F7F7F7;
        word-break: keep-all;
        margin: auto;
        overflow-y: scroll;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    #root {
        height: 100vh;
    }
    *, *::after, *::before {
        box-sizing: border-box;
    }
    
    // tag
    input:not([type="checkbox"], .css-mohuvp-dummyInput-DummyInput), select {

        font-size: 0.875rem;
        height: 2.5rem;
        background-color: ${({ theme }) => theme.newTheme.textField.defaultBg};
        border: 1px solid ${({theme}) => theme.newTheme.textField.defaultBg};
        padding: 0.625rem 1rem;
        border-radius: 0.5rem;

        &:focus,
        &:focus-visible {
            outline: none;
        }
        &:not(:disabled, :read-only):focus,
        &:not(:disabled, :read-only):focus-visible {
            background-color: ${({ theme }) => theme.newTheme.textField.activeBg};
            border: 1px solid ${({ theme }) => theme.newTheme.default.primary};
        }
        &:disabled, &:read-only {
            color: ${({ theme }) => theme.newTheme.textField.disabledText};
            cursor: default;
        }
        &:disabled {
            background-color: ${({ theme }) => theme.newTheme.textField.disabledBg};
        }

    }
    // css로 시작, -control로 끝나는 class(.css*-control)가 input[type='text']를 가지고 있다면
    // select-option 중 isSearchable이 true인 input
    [class^="css"][class$="-control"]:has(input[type='text']) {
        input[type='text'] {
            height: auto;
        }
    }

    textarea {
        width: 100%;
        min-height: 120px;
        height: 100%;
        resize: none;
        border-radius: 0.5rem;
        padding: 0.625rem 1rem;
        background-color: ${({ theme }) => theme.newTheme.textField.defaultBg};
        border: 1px solid ${({ theme }) => theme.newTheme.textField.defaultBg};
        font-size: 0.875rem;

        &:focus,
        &:focus-visible {
            outline: none;
        }
        &:not(:disabled, :read-only):focus,
        &:not(:disabled, :read-only):focus-visible {
            background-color: ${({ theme }) => theme.newTheme.textField.activeBg};
            border: 1px solid ${({ theme }) => theme.newTheme.default.primary};
        }
        &:disabled, &:read-only {
            color: ${({ theme }) => theme.newTheme.textField.disabledText};
            cursor: default;
        }
        &:disabled {
            background-color: ${({ theme }) => theme.newTheme.textField.disabledBg};
        }
    }
    
    input[type="checkbox"] {
        background-color: ${({theme}) => theme.newTheme.text.btnText_w};
        border: 1px solid ${({theme}) => theme.newTheme.border.thirdBd};
        &:focus {
            outline: none;
        }
        &:focus-visible {
            background-color: ${({theme}) => theme.newTheme.textField.activeBg};
            border: 1px solid ${({theme}) => theme.newTheme.default.primary};
        }
    }

    // 자동완성 input
    input:autofill,
    input:autofill:hover,
    input:autofill:focus,
    input:autofill:active {
        -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.newTheme.textField.defaultBg} inset;
        -webkit-text-fill-color: ${({theme}) => theme.newTheme.text.mainText};
        box-shadow: 0 0 0px 1000px ${({ theme }) => theme.newTheme.textField.defaultBg} inset;
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.newTheme.textField.defaultBg} inset;
        -webkit-text-fill-color: ${({theme}) => theme.newTheme.text.mainText};
        box-shadow: 0 0 0px 1000px ${({ theme }) => theme.newTheme.textField.defaultBg} inset;
    }

    p {
        margin: 0;
    }
    
    ul,
    li {
        margin: 0;
        padding: 0;
        list-style: none;
    }
    
    a {
        text-decoration: none;
        cursor: pointer;
        color: ${({theme}) => theme.newTheme.text.mainText};
        &:focus, &:focus-visible {
            border: none;
            outline: none;
        }
        &:active, &:hover, &:visited  {
            color: ${colors.darkGray};
        }
    }
    // button
    button {
        cursor: pointer;
        background: none;
        border: none;
        font-family: var(--font-nanumSquare-acB);
        line-height: 1.25;

        &:focus,
        &:focus-visible {
            outline: none;
        }
    }

    // scrollbar
    ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    ::-webkit-scrollbar-track {
        display: none;
    }
    ::-webkit-scrollbar-thumb {
        background: #E6E6E6;
        border-radius: 6px;
    }
    ::-webkit-scrollbar-corner {
        background: transparent;
    }
`;
export default GlobalStyles;
